import React, { useState, useEffect, useContext } from "react";
import "./Return_Reason_Modal.css";
import { Modal, Form } from "react-bootstrap";
import Common_Button from "../../Common-Component/Common_Button/Common_Button";

import { Context } from "../../../utils/context";
import {
  orderReturn,
  singleOrderGet,
} from "../../../utils/apis/myAccount/myAccount";
import Successfull_Modal from "../Successfull_Modal/Successfull_Modal";

function Return_Reason_Modal(props) {
  const { IMG_URL } = useContext(Context);

  const [order, setOrder] = useState(null);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const getOrder = async () => {
    const res = await singleOrderGet(props.orderId);
    if (res?.success) {
      setOrder(res.data);
    }
  };

  useEffect(() => {
    if (props.orderId) {
      getOrder();
    }
  }, [props.orderId]);

  const handleSubmit = async () => {
    const data = {
      order_id: props.orderId,
      reason,
      remark,
    };

    const res = await orderReturn(data);

    if (res?.success) {
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        props.onHide();
      }, 3000);
    } else {
      setErrorMessage(
        res?.message?.errors?.reason?.msg || "Something went wrong"
      );
    }
  };

  return (
    <div className="Reason_Modal">
      <Modal className="Cancel_Reason_Modal" {...props} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Select a reason for return</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Remark (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Form.Group>

          {errorMessage && <p className="text-danger">{errorMessage}</p>}

          <Common_Button
            onClick={handleSubmit}
            text="Return"
            className="submit-btn"
          />
        </Modal.Body>
      </Modal>

      <Successfull_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message="Return Request Successfully!"
      />
    </div>
  );
}

export default Return_Reason_Modal;
